import { AutogenModelArCycleCode, AutogenRowArCycleCode } from "./autogen/AutogenModelArCycleCode";

export class ModelArCycleCode extends AutogenModelArCycleCode<RowArCycleCode> {
	constructor() {
		super(RowArCycleCode);
	}
}

export class RowArCycleCode extends AutogenRowArCycleCode {
}